import { Injectable } from '@angular/core';

import { DialogMessageService } from '../../services/dialog-message.service';
import { EditingState } from '../../types/util/editingState';

@Injectable({
  providedIn: 'root'
})
export class FormEditingGuard  {

  constructor(private readonly messageService: DialogMessageService) { }

  canDeactivate(component: EditingState): Promise<boolean> | boolean {
    if (component.canDeactivate()) {
      return true;
    }
    const dialogRef = this.messageService.confirmActions('Leave page and discard changes?');
    return dialogRef.afterClosed().toPromise().then(async (choice) => {
      if (choice === 'OK') {
        await component.discardChanges();
        return true;
      }
      else {
        return false;
      }
    });
  }
}
